import lookups from "./lookups.json";

export const CompanyLink = (company, section = 'info') => {
    if (!company)
        return "/"
    if ((company.type || []).includes(lookups.obj.fuel_facility.type.main_company))
        return `/${lookups.obj.fuel_user.branch[(company.category || [])[0]]}/${company._id}/${section}`;
    else
        return `/${lookups.obj.fuel_user.branch.gas_station_company}/${(company.parent || [])[0]}/${(company.type || [])[0]}/${company._id}/${section}`;
};

export const CarrierLink = (carrier, section = 'info') => {
    if (!carrier)
        return "/"

    return `/${lookups.obj.fuel_facility.category.carrier_company}/${carrier._id}/${section}`
};

export const VehicleLink = (vehicle, company) => {
    if (!vehicle)
        return "/"

    return `/${lookups.obj.fuel_facility.category.carrier_company}/${company?._id}/transport/${vehicle?._id}/info`
};

export const UserLink = (user) => {
    if (!user)
        return "/"

    return `/${lookups.obj.fuel_user.branch.administration}/${user._id}/info`
};

export const AlertLink = (alert) => {
    if (!alert)
        return "/"

    return `/${lookups.obj.fuel_user.branch.alert}/${alert._id}/info`
};

export const InvoiceLink = (invoice) => {
    if (!invoice)
        return "/"

    return `/${lookups.obj.fuel_user.branch.invoice}/${invoice._id}/info`
};

export const ContractLink = (contract) => {
    if (!contract)
        return "/"

    return `/${lookups.obj.fuel_user.branch.contract}/${contract._id}/info`;
};

export const TransactionLink = (transaction) => {
    if (!transaction)
        return "/"

    return `/${lookups.obj.fuel_user.branch.transaction}/${transaction._id}/info`
};

export const TransferLink = (transfer) => {
    if (!transfer)
        return "/"

    return `/${lookups.obj.fuel_user.branch.bank_transfer}/${transfer._id}/info`
};

export const IssueLink = (issue) => {
    if (!issue)
        return "/"

    return `/${lookups.obj.fuel_user.branch.help_center}/${issue._id}/info`
};

